<template>
  <q-page class="q-px-md">
    <h1 class="text-h5">Trashed Posts</h1>
    <p>
      <strong>
        Trashed posts are permanently deleted 30 days after they have been trashed.
      </strong>
    </p>
    <trashed-posts-toolbar
      :account-id="accountId"
      :client-id="clientId"
      v-model:filters="filters"
      @update:clientId="selectClient"
    />
    <posts-view-options
      v-model:filters="filters"
      v-model:pagination-mode="paginationMode"
    >
      <trashed-posts-toolbar
        :account-id="accountId"
        :client-id="clientId"
        v-model:filters="filters"
        :maximize-btn="{flat: true}"
        minimized
        @update:clientId="selectClient"
      />
    </posts-view-options>

    <posts
      v-if="filters.socialSiteIds.length"
      :filters="filters"
      :persist="paginationMode === 'scroll'"
      :infinite-scroll="paginationMode === 'scroll'"
      :new-page-top="paginationMode === 'manual'"
    />
  </q-page>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { PostFilters } from '@/type';
import Posts from '../list/Posts.vue';
import TrashedPostsToolbar from './TrashedPostsToolbar.vue';
import { status } from '../post';
import PostsViewOptions from '../list/PostsViewOptions.vue';

interface Data {
  filters: PostFilters,
  paginationMode: 'scroll'|'manual',
}

export default defineComponent({
  components: {
    PostsViewOptions,
    TrashedPostsToolbar,
    Posts,
  },
  props: {
    accountId: {
      type: Number,
      required: true,
    },
  },
  data(): Data {
    return {
      filters: {
        clientIds: [],
        statuses: [status.UNREVIEWED, status.SAVED, status.ESCALATED, status.RESOLVED],
        socialSiteIds: [],
        categoryIds: {},
        isTrashed: true,
        orderBy: 'trashedAt',
        order: 'desc',
      },
      paginationMode: 'scroll',
    };
  },
  computed: {
    clientId(): number|null {
      if (!Array.isArray(this.filters.clientIds)) return null;
      return this.filters.clientIds.length === 1 ? this.filters.clientIds[0] : null;
    },
  },
  methods: {
    selectClient(clientId: number|null): void {
      if (clientId) {
        this.filters.clientIds = [clientId];
      } else {
        this.filters.clientIds = [];
      }
    },
  },
  meta: {
    title: 'Trashed Posts',
  },
});
</script>
